import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

interface MuiCheckboxProps {
  label?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: "small" | "medium";
  disabled?: boolean;
  name?: string;
}

const MuiCheckbox: React.FC<MuiCheckboxProps> = ({
  label,
  checked,
  defaultChecked,
  onChange,
  size = "medium",
  disabled = false,
  name,
}) => {
  return (
    <FormControlLabel
      sx={{ margin: 0 }} // Removes default margin
      control={
        <Checkbox
          checked={checked}
          defaultChecked={defaultChecked}
          onChange={onChange}
          size={size}
          disabled={disabled}
          name={name}
          sx={{
            m: 0,
            pt: 0, // padding-top
            pr: 1, // padding-right
            pb: 0, // padding-bottom
            pl: 1, // padding-left
            "& .MuiSvgIcon-root": {
              width: "20px",
              height: "20px",
            },
          }}
          inputProps={{ "aria-label": label || "checkbox" }}
        />
      }
      label={label || ""}
    />
  );
};

export default MuiCheckbox;
